/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_In_DeliveryInputs */

const vi_dashboard_driver_in_delivery = /** @type {(inputs: Dashboard_Driver_In_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang giao`)
};

/**

* @param {Dashboard_Driver_In_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_in_delivery = /** @type {((inputs?: Dashboard_Driver_In_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_In_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_in_delivery(inputs)
});